export default __webpack_public_path__ + "static/media/cortex-logo-vertical.c98d49d6.png";